import React from 'react';
import PublicSiteHeader from '../layout/PublicSiteHeader';
import SiteFooter from '../layout/SiteFooter';

// The full-page frame for the signed-out auth forms (Login, Create Account,
// Reset Password): the beige marketing nav over the white page, a top-aligned
// ~420px column, then the site footer. `children` are the form's own contents —
// the shell only positions them.
export function AuthPageShell({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex min-h-screen flex-col bg-page text-ink-secondary">
            <PublicSiteHeader />
            <main className="flex flex-1 justify-center px-5 pb-[72px] pt-[clamp(24px,5vw,56px)]">
                <div className="flex w-full max-w-[420px] flex-col pt-[clamp(8px,2vw,24px)]">{children}</div>
            </main>
            <SiteFooter />
        </div>
    );
}

// The column header: the ghosted "Organic Electronics" label, the big 800-weight
// title, and the charcoal hairline under it.
export function AuthFormHeading({ title }: { title: string }) {
    return (
        <>
            <span className="text-[13px] font-semibold text-subtle">Organic Electronics</span>
            <h1 className="mt-0.5 text-[clamp(28px,4vw,34px)] font-extrabold leading-[1.1] tracking-[-0.02em]">
                {title}
            </h1>
            <div className="mt-3.5 h-px bg-[rgb(148,148,147)]" />
        </>
    );
}

// The lighter 2px rule that separates the form / Google / cross-link blocks
// (the heading rule above is darker — rgb(148,148,147)).
export function AuthRule({ className = '' }: { className?: string }) {
    return <div className={`h-0.5 bg-[rgb(229,229,229)] ${className}`} />;
}

// The "New here? / Create account" row at the foot of the column.
export function AuthCrossLink({
    prompt,
    label,
    onClick,
}: {
    prompt: string;
    label: string;
    onClick: () => void;
}) {
    return (
        <div className="mt-[18px] flex items-baseline justify-between gap-3">
            <span className="text-[13px] text-[#6E6E6E]">{prompt}</span>
            <button
                type="button"
                onClick={onClick}
                className="border-b-[1.5px] border-[rgba(41,41,39,0.45)] pb-0.5 text-[14px] font-extrabold text-ink-secondary transition-colors hover:text-ink"
            >
                {label}
            </button>
        </div>
    );
}

export default AuthPageShell;
